import { FC } from 'react'
import classNames from 'classnames'
import { ColorType } from 'common/types/color-type' // we need this to make JSX compile

type PoweredByHeroType = {
  className: string
  background: ColorType
}

const PoweredByHero: FC<PoweredByHeroType> = ({
  background,
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        'hero hero--powered-by',
        `bg-${background}`,
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PoweredByHero
